<template>
  <a-card title="Recent Events" class="Custom--Card">
    <template slot="extra">
      <a-button type="default" shape="circle" size="small" icon="sync" @click="dispatchMutations(true)"/>
      <a-divider type="vertical" />
      <router-link :to="{ name:'eventlogs.all' }" v-if="isAdmin()">view all</router-link>
    </template>


    <a-list itemLayout="horizontal" :dataSource="events" :loading="loading">
      <a-list-item slot="renderItem" slot-scope="item" style="font-size: .5em;">
        <a-list-item-meta>
          <a slot="title" style="margin-left: -15px; font-size: .8em;">
            <a-tooltip placement="top" @click="showModal(item)">
              <template slot="title">
                <span>{{ item.message }}</span>
              </template>
              {{ item.message | excerpt }}
            </a-tooltip>
            <span style="float: right; font-size: .7em; color: #7f8c8d;">{{ item.created_at }}</span>
          </a>
          <a-avatar slot="avatar" style="background:#fff; font-size: .7em;">
            <i
              v-if="item.status == 'success'"
              class="fa fa-paper-plane"
              aria-hidden="true"
              style="color: green;font-size: .8rem"
            ></i>
            <i
              v-if="item.status == 'failed'"
              style="color:yellow; font-size: .8rem"
              class="fa fa-exclamation-triangle"
              aria-hidden="true"
            ></i>
          </a-avatar>
        </a-list-item-meta>
      </a-list-item>
    </a-list>
    <a-modal
      :title="modal.title"
      :visible="modal.visible"
      :width="modal.width"
    >
      <a-row v-if="modal.data.data">
        <a-col>
          <strong>Details:</strong> <br>
          <p :style="{ fontSize: '.9em', fontWeight: 'normal', marginTop: '10px' }">
            {{ modal.data.data.message }}
          </p>
          <template v-if="modal.data.data.error">
            <strong :style="{ marginTop: '15px' }">Details:</strong> <br>
            <p :style="{ fontSize: '.9em', fontWeight: 'normal', marginTop: '10px' }">
              {{ modal.data.data.error }}
            </p>
          </template>
          <p :style="{ marginTop: '30px' }">
            <strong>Status:</strong> &nbsp;&nbsp;
            <span v-if="modal.data.data.status === 'success'" :style="{ color: 'green' }">{{ modal.data.data.status | capitalize }}</span>
            <span v-else :style="{ color: 'darkred' }">{{ modal.data.data.status | capitalize }}</span>
          </p>
          <p>
            <strong>Created:</strong>&nbsp;&nbsp;{{ modal.data.created_at }}
          </p>
        </a-col>
      </a-row>
      <hr v-if="isAdmin()">
      <a-row :style="{ marginTop: '18px' }" v-if="modal.data.data && isAdmin() ">
        <template v-if="modal.data.data.type === 'campaign_completed'">
          <a-col :span="24">
            <router-link :to="'/' + modal.data.data.redirect" tag="a">
              Go to campaign page
            </router-link>
          </a-col>
        </template>
        <template v-if="modal.data.data.type === 'campaign_failed'">
          <a-col :span="24">
            <router-link :to="modal.data.data.redirect" tag="a">
              Go to the campaign
            </router-link>
          </a-col>
        </template>
        <template v-if="modal.data.data.type === 'campaign_paused'">
          <a-col :span="24">
            <router-link :to="'/' + modal.data.data.redirect" tag="a">
              Go to campaign page
            </router-link>
          </a-col>
        </template>
        <template v-if="modal.data.data.type === 'campaign_resumed'">
          <a-col :span="24">
            <router-link :to="'/' + modal.data.data.redirect" tag="a">
              Go to campaign page
            </router-link>
          </a-col>
        </template>
        <!-- Sites -->
        <template v-if="modal.data.data.type === 'site_registered'">
          <a-col :span="24">
            <router-link :to="'/sites/' + record.notifiable_id" tag="a">
              Go to Site Page
            </router-link>
          </a-col>
        </template>
        <!-- Import -->
        <template v-if="modal.data.data.type === 'import_completed'">
          <a-col :span="24">
            <router-link :to="'/admin' + modal.data.data.redirect" tag="a">
              Go to the list
            </router-link>
          </a-col>
        </template>
        <!-- <template v-if="modal.data.data.type === 'import_failed'">
          <a-col :span="24">
            <strong>{{ modal.data.data.message }}</strong>
            <p v-if="modal.data.data.error">
              <small>{{ modal.data.data.error }}</small>
            </p>
          </a-col>
        </template> -->
      </a-row>
      <template slot="footer">
        <a-button key="back" type="default" @click="closeModal">Close</a-button>
      </template>
    </a-modal>
  </a-card>
</template>
<script>
import {mapGetters, mapState} from "vuex";

export default {
  data() {
    return {
      interval: null,
      modal: {
        title: '',
        width: 800,
        visible: false,
        data: {}
      },
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      events: "dashboard/getEvents"
    }),
    ...mapState('auth', ["role"]),
  },
  methods: {
    dispatchMutations(refresh = false) {
      this.loading = true;

      this.$store.dispatch('dashboard/getEvents', {refresh: refresh, context: this});
      this.interval = setTimeout(() => {
          this.dispatchMutations();
      }, 60000);
    },

    showModal(item) {
      this.modal.visible = true;
      this.modal.title = item.message;
      this.modal.data = item;
    },
    closeModal() {
      this.modal.visible = false;
    },

    handleResize() {
      let windowSize = window.innerWidth;
      if (windowSize < 650) {
        this.modal.width = (window.innerWidth - 5);
      }
    },

    isAdmin() {
      return this.role === 'wemail_admin';
    },
    isAnalyst() {
      return this.role === 'wemail_analyst';
    }
  },
  created() {
    this.dispatchMutations();
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
      clearTimeout(this.interval);
      window.removeEventListener('resize', this.handleResize);
  }
};
</script>
<style scoped>
.Custom--Card {
  padding: 0 !important;
}
.ant-list-item-meta-description { font-size: .6rem; }
hr { height: 1px; border: none; background: #e7e7e7;  }
</style>

